import { __rest } from "tslib";
import React, { forwardRef } from 'react';
import cn from 'classnames';
import { Transition } from 'react-transition-group';
import "./Overlay.css";
var styles = { "container": "a93216", "container_entered": "b62fc7" };
const Overlay = forwardRef((_a, ref) => {
    var { isIn, children } = _a, props = __rest(_a, ["isIn", "children"]);
    return (React.createElement(Transition, { in: isIn, timeout: {
            appear: 0,
            enter: 0,
            exit: 300,
        }, mountOnEnter: true, unmountOnExit: true }, (transitionState) => (React.createElement("div", Object.assign({ ref: ref, role: "presentation", className: cn(styles.container, transitionState && styles[`container_${transitionState}`]) }, props), children))));
});
export default Overlay;
//# sourceMappingURL=Overlay.js.map